/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
const o=1/255.5,t=1-o;export{o as alphaCutoff,t as opacityCutoff};
